import styled from "styled-components";
import ID_SVG from "../../../images/id.svg";
import PW_SVG from "../../../images/pw.svg";
import Input from "./Input";
import useLogin from "../../../hooks/authorization/useLogin";
import Modal from "../../common/Modal";
import { useNavigate } from "react-router-dom";

function Form(){
    const {onEnterPressed, onLoginClickHandler, inputs, onChange, isOpenModal, modal, onLoginModalConfirmClickHandler} = useLogin();
    const navigate = useNavigate();
    return(
        <Container>
            <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} onClose={onLoginModalConfirmClickHandler}/>
            <Title>로그인</Title>
            <Wrapper >
                <Input icon={ID_SVG} placeholder="아이디 입력" name="id" value={inputs.id} onChange={onChange}/>
                <Input type="password" icon={PW_SVG} placeholder="비밀번호 입력" name="pw" value={inputs.pw} onChange={onChange} onKeyDown={onEnterPressed}/>
                <Button onClick={onLoginClickHandler}>로그인</Button>
                <Label onClick={() => navigate("/register")}>회원가입</Label>
            </Wrapper>
            
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    gap: 40px;
    margin-top: 160px;
    margin-bottom: 120px;
`

const Title = styled.span`
    color: black;
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 400px;
    width: 100%;
    padding: 20px;
    gap: 12px;
`

const Label = styled.div`
    margin-left: 4px;
    color: #555;
    font-size: 14px;
    cursor: pointer;
`

const Button = styled.button`
    background: #007912;
    border-radius: 12px;
    border: none;
    padding:12px;
    width: 100%;
    color: #FFF;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
`

export default Form;